/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsCancelAliases {
  AUTOCOMPLETE_CANCEL_REASON_LIST = 'autocomplete-cancel-reason-list',
  BUTTON_CONFIRM_CANCELLATION = 'button-confirm-cancellation',
  FETCH_CANCEL_REASON_LIST = 'fetch-cancel-reason-list',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_CANCEL_REASON_LIST = 'field-cancel-reason-list',
  FORM_CANCEL = 'form-cancel',
  LAYOUT_APPOINTMENT_CANCEL = 'layout-appointment-cancel',
  LAYOUT_CANCEL = 'layout-cancel',
  LOADER = 'loader',
  MAPPER_CANCEL_REASON = 'mapper-cancel-reason',
  PANEL_ACTION = 'panel-action',
  PANEL_CANCEL = 'panel-cancel',
  PANEL_FORM = 'panel-form',
  PANEL_LOADER = 'panel-loader',
  TEXT_CANCEL_REASON = 'text-cancel-reason',
  TEXTAREA_CANCEL_REASON = 'textarea-cancel-reason',
}
export { PseudonymAppointmentsCancelAliases };
